import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "OwlWorkLabs | UK Venture Studio Building Intelligent Systems",
  description = "OwlWorkLabs is a UK-based venture studio that identifies meaningful problems and builds scalable products at the intersection of technology, sustainability, and community.",
  canonical = "https://www.owlworklabs.com",
  type = "website",
  image = "https://www.owlworklabs.com/og-image.png"
}) => {
  return (
    <Helmet prioritizeSeoTags>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonical} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
